import { render, staticRenderFns } from "./LayoutApprovals.vue?vue&type=template&id=29d98ce3"
import script from "./LayoutApprovals.vue?vue&type=script&lang=js"
export * from "./LayoutApprovals.vue?vue&type=script&lang=js"
import style0 from "./LayoutApprovals.vue?vue&type=style&index=0&id=29d98ce3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports